/**
 * Service API pour analytics de rentabilité employé/client
 */
import api from "./api";

/**
 * Récupère la rentabilité enrichie d'un employé
 * @param {string} employeeId - ID de l'employé
 * @param {object} params - Paramètres optionnels (start_date, end_date)
 * @returns {Promise} Données de rentabilité employé
 */
export async function getEmployeeProfitability(employeeId, params = {}) {
  const response = await api.get(`/api/production/employees/${employeeId}/profitability/analytics`, { params });
  return response.data;
}

/**
 * Récupère la rentabilité enrichie d'un client
 * @param {string} clientId - ID du client
 * @param {object} params - Paramètres optionnels (start_date, end_date)
 * @returns {Promise} Données de rentabilité client
 */
export async function getClientProfitability(clientId, params = {}) {
  const response = await api.get(`/api/production/clients/${clientId}/profitability/analytics`, { params });
  return response.data;
}
